"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchUser = void 0;
const react_1 = __importStar(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const Autocomplete_1 = require("../Autocomplete/Autocomplete");
const SearchUserBadge_1 = require("./SearchUserBadge");
const SearchUserItem_1 = require("./SearchUserItem");
const className = 'search-user';
const SearchUser = (props) => {
    const { value, setValue, items, toItem, query = '', setQuery, placeholder, label, hidden, additionClassNames, } = props;
    const selected = value ? toItem(value) : undefined;
    const userBadge = (0, react_1.useMemo)(() => {
        if (!(selected === null || selected === void 0 ? void 0 : selected.name))
            return undefined;
        const searchUserBadgeProps = {
            userName: selected.name,
            userType: selected.userType,
            onCloseClick: () => setValue === null || setValue === void 0 ? void 0 : setValue(undefined),
        };
        return react_1.default.createElement(SearchUserBadge_1.SearchUserBadge, { ...searchUserBadgeProps });
    }, [setValue, selected === null || selected === void 0 ? void 0 : selected.name, selected === null || selected === void 0 ? void 0 : selected.userType]);
    const onChangeHandler = (0, react_1.useCallback)((e) => {
        setQuery === null || setQuery === void 0 ? void 0 : setQuery(e.target.value);
    }, [setQuery]);
    const autocompleteProps = {
        placeholder,
        label,
        className: (0, classFunctions_1.getClassNames)(className, undefined, additionClassNames),
        onChange: onChangeHandler,
        value: query,
        addon: userBadge,
        addonWidth: '200px',
    };
    if (hidden)
        return null;
    return (react_1.default.createElement(Autocomplete_1.Autocomplete, { ...autocompleteProps }, items === null || items === void 0 ? void 0 : items.map(item => {
        const mappedItem = toItem(item);
        return (react_1.default.createElement(SearchUserItem_1.SearchUserItem, { key: mappedItem.id, isSelected: mappedItem.id === (selected === null || selected === void 0 ? void 0 : selected.id), onClick: () => setValue === null || setValue === void 0 ? void 0 : setValue(item), ...mappedItem }));
    })));
};
exports.SearchUser = SearchUser;
//# sourceMappingURL=index.js.map